import React, { useState, useEffect } from 'react';
import {
  Box,
  Tabs,
  Tab,
  useTheme,
  useMediaQuery
} from '@mui/material';
import GuidGenerator from '../GuidGenerator';
import PasswordGenerator from '../PasswordGenerator';
import PasswordStrengthChecker from '../PasswordStrengthChecker';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`utilities-tabpanel-${index}`}
      aria-labelledby={`utilities-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 2 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `utilities-tab-${index}`,
    'aria-controls': `utilities-tabpanel-${index}`,
  };
}

const tabKeyMap: { [key: string]: number } = {
  'guid-generator': 0,
  'password-generator': 1,
  'password-strength': 2,
};

interface UtilitiesPageProps {
  initialTabKey?: string;
}

const UtilitiesPage: React.FC<UtilitiesPageProps> = ({ initialTabKey }) => {
  const [value, setValue] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    if (initialTabKey && tabKeyMap[initialTabKey] !== undefined) {
      setValue(tabKeyMap[initialTabKey]);
    }
  }, [initialTabKey]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="security utilities tabs"
          variant={isMobile ? 'scrollable' : 'fullWidth'}
          scrollButtons={isMobile ? 'auto' : false}
          allowScrollButtonsMobile
        >
          <Tab label="GUID Generator" {...a11yProps(0)} />
          <Tab label="Password Generator" {...a11yProps(1)} />
          <Tab label="Password Strength Checker" {...a11yProps(2)} />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <GuidGenerator />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <PasswordGenerator />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <PasswordStrengthChecker />
      </TabPanel>
    </Box>
  );
};

export default UtilitiesPage;
